/* eslint-disable max-len */
import React from 'react'
import {useState} from 'react'
import GlobalContext from '../../../../components/Context/GloablContext'
import ErrorMessage from '../../../../components/ErrorMessage'
import Loader from '../../../../components/Loader'
import {useContext,useEffect} from 'react'
import OtpInputField from '../../../../components/OtpInput/index'
import { Auth } from 'aws-amplify';
import { useDispatch } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { verifyOtp } from '../../authSlice'
import { Link } from 'react-router-dom'
import { logIn ,setUserType} from '../../authSlice'
import { getValidatedRedirect } from '../../../../CommonMethods/redirectUtils'
import refreshIdToken from '../../../../CommonMethods/RefreshIdFunction'
import { userService } from '../../../../services/user.services'
import { persistAuthSession, broadcastLogin, getAuthItem, setAuthItem } from '../../../../CommonMethods/authSession';
import MaskedEmail from '../../../../CommonMethods/MaskedEmail'
import authenticateUser from '../../../../config/aws-export'
import { deleteWholeDatabase } from '../../../../components/HelpGuideModal/indexDB'

export default function OtpPage({setIsTrustMyBrowser,handleLogin,duration,userData,selectedPreference,loginCredentials,setDisplayOtpScreen,setOtp,otp,displayOtpScreen,
    handelClear,setIsForgotPassword,setPreferenceModel,preferenceModel,setIsLoginPage,setloginCredentials,setSelectedPreference,loginData}) {
    const dispatch=useDispatch()
    const navigate=useNavigate()
    const location=useLocation()
    const { setToastmessage, UpdateCall, setUpdateCall,setToastErrorMessage ,setIsSideBar,WebSocketConnection, fetchAndCacheHelpGuides} = useContext(GlobalContext)

    // Read the deep-link redirect from the login URL (e.g. /?redirect=/dashboard).
    const getRedirectPath = (defaultPath) => {
        const searchParams = new URLSearchParams(location.search);
        return getValidatedRedirect(searchParams) || defaultPath;
    };
    // const [IsLoginPage, setIsLoginPage] = useState(true);
    const [loading, setloading] = useState(false);
    const [myInfo, setmyInfo] = useState({})
    const {email,password}=loginCredentials

    const [error, seterror] = useState(false);
    const [errorMsg,setErrorMsg]=useState("")
    // const [otp, setOtp] = useState(Array(6).fill(""));
    const [timer, setTimer] = useState(parseInt(sessionStorage.getItem('duration')));
    const [loginError, setloginError] = useState('')
    const handleRefreshToken = async () => {
        if(sessionStorage.getItem('IdToken')){
            refreshIdToken()
        }        
    };
    useEffect(() => {
        let intervalId;

        if (timer > 0) {
            intervalId = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);
        }

        return () => {
            clearInterval(intervalId);
        };
    }, [timer]);

    const handleResendOTP = async() => {
        // Handle resend OTP logic here
        // Reset the timer to 30 seconds
        const preference_id = sessionStorage.getItem('preference_id');
        const response = await userService.resendOtp(preference_id)
        if(response.error === false) {
            setPreferenceModel(false)
            setToastmessage(response.data.message)
            setTimer(parseInt(response.data.otp_resend_duration))
        } else{
            setPreferenceModel(false)
            setToastErrorMessage('Something went wrong !!!')
        }
    };

    const handleBacktoLogin = (e) => {
        setSelectedPreference([])
        setloginCredentials({
            email: '',
            password: ''
        });
        e.preventDefault();
        setDisplayOtpScreen(false)
        setIsForgotPassword(false)
        setIsLoginPage(true)
        // navigate('/')
    }

    
    const handleOTPVerification = async (e) => {
        e.preventDefault();
        setloading(true)
        deleteWholeDatabase()
        const response = await userService.verifyLoginOtp(otp.join(''))
        if(response.error){
            seterror(true)
            setErrorMsg(response.message.response.data.message)
            if(response.message.response.data.message === "Invalid OTP entered more than specified times in the system configuration"){
                setToastErrorMessage("Invalid OTP entered more than specified times in the system configuration")
                handleBacktoLogin(e)
            }
            setloading(false)
            return
        } else{
            const existingUserType = getAuthItem('user_type');
            const firstName = sessionStorage.getItem('first_name');
            const lastName = sessionStorage.getItem('last_name');
            persistAuthSession({
                AccessToken: response.data.AccessToken,
                RefreshToken: response.data.RefreshToken,
                IdToken: response.data.IdToken,
                currentTimestamp: ((new Date).getTime().toString()),
                user_id: response.data.user_id,
                id: response.data.id,
                browser_trust_duration: response.data.browser_trust_duration,
                ...(existingUserType && { user_type: existingUserType }),
                ...(firstName && { first_name: firstName }),
                ...(lastName && { last_name: lastName }),
            });

            if(loginData?.data?.isLoggedIn===true){
                await userService.DuplicateTabClose('')
            }

            if (response?.data?.message === "Please reset your password.") {
                broadcastLogin();
                WebSocketConnection()
                setAuthItem('custom:is_first_time_login', 'true');
                sessionStorage.setItem('email', email);


                setToastmessage('Login successful')
                refreshIdToken()
                const intervalId = setInterval(handleRefreshToken, 9 * 60 * 1000);
                // Preserve the deep-link redirect so ResetPassword can restore it after logout
                navigate('/reset',{ state: {'refresh_interval':intervalId, redirect: getRedirectPath(null)} })
                return
                // location('/reset-password')
            }
            if(response.error === false && (response.data.redirect_to_trust_my_browser === true || response.data.redirect_to_trust_my_browser === 'true')) {
                sessionStorage.setItem('trust_browser_flow_active', 'true');
                setIsTrustMyBrowser(true)
                setIsSideBar(false)
                authenticateUser(email.toLowerCase().trim().replace(/\s/g, ''),password)
                refreshIdToken()
                setDisplayOtpScreen(false)
                setAuthItem('custom:is_first_time_login', 'false');
            } else {
                broadcastLogin();
                WebSocketConnection()
                fetchAndCacheHelpGuides()
                // Normal OTP success: complete login and navigate to the intended destination
                setAuthItem('custom:is_first_time_login', 'false');
                dispatch(logIn());
                setIsSideBar(false);
                setloading(false);
                setToastmessage('Login successful');
                const userType = sessionStorage.getItem('user_type');
                const defaultPath = userType === 'monitor-user' ? '/manage-dashboard' : '/alerts-notifications';
                navigate(getRedirectPath(defaultPath));
            }
        }
    };
    return (
        <div className='w-[35%] 2xl:w-[30%]' >
            <div className='w-[280px] xl:[290px] 2xl:w-[320px] flex flex-col justify-center items-center h-screen'>
                <div className='w-full'>
                    <img src="/images/Arcm_login_logo.svg" alt="Banner-Img" className='w-fit h-fit mx-auto' />
                    <h1 className='mt-6 text-[36px] font-normal text-[#000] text-center'>OTP Verification</h1>
                    {/*  */}
                    <h1 className='text-lg font-normal text-[#777C88] text-center'>Enter the 6-digit OTP sent to </h1>
                    <h1 className='text-lg font-normal pb-[10px] text-[#777C88] text-center'>
                        {selectedPreference.otp_preference_mode === 'email' ? (
                            <MaskedEmail value={selectedPreference.preference} />
                        ) : (
                            `${selectedPreference?.country_code} ${selectedPreference?.preference?.slice(0, 2) 
      + '*'.repeat(selectedPreference?.preference?.length - 4) 
      + selectedPreference?.preference?.slice(-2)}`
                        )}                        
                    </h1>
                    <form onSubmit={(e)=>handleOTPVerification(e)}>
                        <div className="digit-group flex justify-center pt-1.5">
                            
                            <OtpInputField
                                onChange={setOtp}
                                inputs={otp}
                                setInputs={setOtp}
                                value={otp}
                                inputType="tel"
                                shouldAutoFocus	
                                inputStyle="w-14 h-12 border-b-2 sm:mr-6 mr-5 border-[#A9B2BE] bg-[transparent] outline-0 text-center text-xs4 font-normal otp-input err-otp text-[#0D1B2A]"
                                numInputs={6}
                                error={error}
                                seterror={seterror}
                                renderInput={(props) => <input {...props} />}
                                separator={<span></span>}
                            />
                        </div>
                        {/* errormessage */}
                        {error &&<ErrorMessage error={error} message={errorMsg} classKey="text-xs font-normal text-[#C81720] mt-3 text-center" />}
                        {/* <p className='text-xs font-normal text-[#C81720] mt-3 text-center'>You entered an invalid OTP. Please try again</p>  */}
                        <p className='mt-3 text-center text-xs font-normal text-[#777C88]'>Didn’t receive OTP?</p>
                        <div className='w-fit mx-auto'>
                            {timer===0?<><button 
                                onClick={(e)=>{
                                    // handleLogin(e,'resend');
                                    setOtp(Array(6).fill(""))
                                    handleResendOTP()
                                }}
                                disabled={timer>0||loading}
                                type="button"
                                className={`text-xs font-semibold text-[#008586] `}>
                                Resend OTP</button></>:<><span className={`text-xs font-semibold ${timer>0?'text-[#777C88]':'text-[#008586]'}`}>Resend OTP in </span><span className={`text-xs font-semibold ${'text-[#008586]'}`}>{timer.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})}s</span></>
                            }
                         
                        </div>
                        <button type='submit'
                            id="otp-form"
                            disabled={otp.includes("")||loading||errorMsg==="Invalid session for the user."}
                            className='w-full mt-8 py-2.5 px-2 text-lg font-semibold text-[#fff] rounded-[16px] 
                            bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]'>
                            {!loading?' Verify OTP':<span>{<Loader/>}</span>}
                        </button>
                        <div className='flex justify-center w-full mt-6'>
                            <button disabled={loading} onClick={(e)=>{handleBacktoLogin(e)}} className='flex items-center'>
                                <span className='text-lg font-normal text-[#008586] ml-3'>Back to Login</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
